import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {Editable} from './Editable';
import {ProfileFormType} from '../../types';

interface Props {
  minSalaryValue?: number | null;
  maxSalaryValue?: number | null;
  onEdit?: (type: ProfileFormType) => void;
}

export const SalaryExpectations = ({minSalaryValue, maxSalaryValue, onEdit}: Props) => {
  const {t} = useTranslation();
  const formatSalary = (min?: number | null, max?: number | null): string => {
    if (!!min && !!max) {
      return `€${min} - €${max}`;
    }
    if (!!min && !max) {
      return `min €${min}`;
    }

    if (!min && !!max) {
      return `max €${max}`;
    }
    return '-';
  };
  const onEditHandler = () => {
    onEdit && onEdit('salary-expectations');
  };
  return (
    <Editable onEdit={onEditHandler}>
      <Box>
        <Typography variant='h2' paddingBottom='16px'>
          {t('applicantProfile.salaryExpectations.title')}
        </Typography>
        <Typography variant='body1'>{formatSalary(minSalaryValue, maxSalaryValue)}</Typography>
      </Box>
    </Editable>
  );
};
